// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview .wrapper_box {
  background-color: #ffffff;
  overflow: hidden;
  width: 100%;
  margin-right: 15px;
  margin-left: 15px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  padding: 25px;
}
@media (max-width: 1299px) {
.overview .wrapper_box {
    padding: 10px 45px 10px 10px;
}
}
.overview .vertical-bar {
  border-left: 1px solid #d6d6d6;
  height: 100%;
  position: absolute;
  left: 98%;
  margin-left: -3px;
  top: 0;
}
.overview .vertical-bar:last-child {
  display: none;
}
@media (max-width: 1600px) {
.overview .vertical-bar {
    left: 97%;
}
}
@media (max-width: 1399px) {
.overview .vertical-bar {
    display: none;
}
}
@media (max-width: 576px) {
.overview .file-budget .card-header button.btn {
    padding-left: 35px;
}
.overview .card-header .fa-icon {
    left: 20px;
}
}
.overview .apexcharts-series.apexcharts-pie-series {
  cursor: pointer;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
